import { render } from "./InfoClickWin.vue?vue&type=template&id=178d1aaf"
import script from "./InfoClickWin.vue?vue&type=script&lang=js"
export * from "./InfoClickWin.vue?vue&type=script&lang=js"

import "./InfoClickWin.vue?vue&type=style&index=0&id=178d1aaf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__